export default __webpack_public_path__ + "static/media/split-bill-step-3.ab96881a.png";